import React from 'react';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';

var FlagDE = function FlagDE() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Group, {
    id: "germany"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M174.873467,120 L5.12100983,120 C17.475726,154.955772 50.8118738,180 89.9972382,180 C129.182603,180 162.51875,154.955772 174.873463,120 L174.873467,120 L174.873467,120 Z",
    id: "yellow",
    fill: "#F2C500"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M5.12100983,120 L174.873467,120 C178.189905,110.616633 179.994476,100.519063 179.994476,90 C179.994476,79.480937 178.189905,69.3833673 174.873463,59.9999996 L5.12100983,60 C1.80457108,69.3833673 0,79.480937 0,90 C0,100.519063 1.80457108,110.616633 5.12101363,120 L5.12100983,120 L5.12100983,120 Z",
    id: "red",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M5.12100983,60 L174.873467,60 C162.51875,25.0442275 129.182603,0 89.9972382,0 C50.8118738,0 17.475726,25.0442275 5.12101363,59.9999996 L5.12100983,60 L5.12100983,60 Z",
    id: "black",
    fill: "#000000"
  })));
};

FlagDE.displayName = 'FlagDE';
export default withFlagWrapper(FlagDE);
//# sourceMappingURL=index.js.map